import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name || !email || !password || !confirmPassword) {
      toast.error('Bütün xanaları doldurun');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Şifrələr uyğun gəlmir');
      return;
    }

    if (password.length < 6) {
      toast.error('Şifrə minimum 6 simvol olmalıdır');
      return;
    }

    setLoading(true);
    try {
      await register(email, password, name, phone);
      toast.success('Qeydiyyat uğurla tamamlandı!');
      navigate('/');
    } catch (error) {
      console.error('Register error:', error);
      if (error.code === 'auth/email-already-in-use') {
        toast.error('Bu email artıq istifadə olunur');
      } else if (error.code === 'auth/weak-password') {
        toast.error('Şifrə çox zəifdir');
      } else {
        toast.error('Qeydiyyat zamanı xəta baş verdi');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-dark flex items-center justify-center px-4 pt-24 pb-10" data-testid="register-page">
      <div className="w-full max-w-md">
        {/* Form Card */}
        <div className="glass-dark p-8 border border-gray-700 rounded-xl">
          <h1 className="text-2xl font-bold text-white text-center mb-8">
            Qeydiyyat
          </h1>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="name" className="text-gray-400 font-medium">Ad Soyad</Label>
              <Input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ad Soyad"
                className="mt-2 bg-black/50 border-gray-700 text-white focus:border-red-500"
                data-testid="register-name"
              />
            </div>

            <div>
              <Label htmlFor="email" className="text-gray-400 font-medium">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@example.com"
                className="mt-2 bg-black/50 border-gray-700 text-white focus:border-red-500"
                data-testid="register-email"
              />
            </div>

            <div>
              <Label htmlFor="phone" className="text-gray-400 font-medium">Telefon (İstəyə bağlı)</Label>
              <Input
                id="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+994 50 XXX XX XX"
                className="mt-2 bg-black/50 border-gray-700 text-white focus:border-red-500"
                data-testid="register-phone"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-gray-400 font-medium">Şifrə</Label>
              <div className="relative mt-2">
                <Input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-black/50 border-gray-700 text-white focus:border-red-500 pr-10"
                  data-testid="register-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <div>
              <Label htmlFor="confirmPassword" className="text-gray-400 font-medium">Şifrəni Təkrarla</Label>
              <Input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-2 bg-black/50 border-gray-700 text-white focus:border-red-500"
                data-testid="register-confirm-password"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full btn-primary text-white py-6 rounded-lg font-bold text-lg"
              data-testid="register-submit"
            >
              {loading ? 'Qeydiyyat edilir...' : 'Qeydiyyatdan Keç'}
            </Button>
          </form>

          <p className="text-gray-400 text-center mt-6">
            Hesabınız var?{' '}
            <Link to="/login" className="text-red-400 hover:underline font-semibold">
              Daxil olun
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
